import { render } from "./BorderBlockEndWidth.vue?vue&type=template&id=1d3658d8&scoped=true&ts=true"
import script from "./BorderBlockEndWidth.vue?vue&type=script&lang=ts"
export * from "./BorderBlockEndWidth.vue?vue&type=script&lang=ts"

import "./BorderBlockEndWidth.vue?vue&type=style&index=0&id=1d3658d8&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3658d8"]])

export default __exports__